import { defineInlineEdit } from "../../../../components/MobileList/inlineEdit";

/**
 * views/POS/form PUTs 34 keys, most of which the list row cannot supply — the
 * wallet limits, the transfer caps and the feature flags all live on the detail
 * only, and the relations arrive as objects the payload flattens to ids. So the
 * detail is always fetched and `toPayload` mirrors the form's update branch key
 * for key, including its `is_approved ? 1 : 0` coercion.
 *
 * Only the two plain scalars on the card are editable. `password` is excluded
 * (own endpoint + `change_password_edit`), and so are the rep, group and
 * province: province drives the city list, so changing one without the other
 * would leave the point of sale in an inconsistent location.
 */
export default defineInlineEdit({
  api: "pos",
  permission: "pos_edit",
  hydrate: true,
  toPayload: (detail) => ({
    name: detail.name,
    owner: detail.owner,
    mobile: detail.mobile,
    group_id: detail.group?.id,
    can_transfer: detail.can_transfer,
    province_id: detail.province?.id,
    address: detail.address,
    wage: detail.wage,
    max_daily_transfer: detail.max_daily_transfer,
    max_monthly_transfer: detail.max_monthly_transfer,
    user_name: detail.user_name,
    max_balance: detail.wallet?.max_balance,
    max_debt: detail.wallet?.max_debt,
    min_balance: detail.wallet?.min_balance ?? 50000,
    e_payment_rep_id: detail.e_payment_rep_id ?? null,
    j_rep_id: detail.j_rep_id ?? null,
    city_id: detail.city?.id,
    daily_transfer_balance: detail.daily_transfer_balance,
    is_approved: detail.is_approved ? 1 : 0,
    latitude: detail.latitude,
    longitude: detail.longitude,
    has_card_recharge: detail.has_card_recharge,
    has_card_issuing: detail.has_card_issuing,
    has_external_orders: detail.has_external_orders,
    has_e_payment: detail.has_e_payment,
    sim_card_number: detail.sim_card_number,
    pos_type_id: detail.pos_type_id,
    pos_field_id: detail.pos_field_id,
    j_group_id: detail.j_group_id,
    other_id: detail.other_id ?? "",
    lock_after_payment: detail.lock_after_payment,
    rep_id: detail.representative?.id ?? null,
  }),
  fields: {
    name: { label: "الاسم", type: "text", required: true },
    sim_card_number: {
      label: "رقم الشريحة",
      type: "text",
      inputProps: { inputMode: "tel", dir: "ltr" },
    },
  },
});
